export default __webpack_public_path__ + "static/media/blend-graph.4fcda4a8.svg";